import React from 'react'
import icon from './svgs/statistics_fall.svg'
import { BaseIcon } from './_base'

export const StatisticsFallIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
